import { Box, Flex } from 'rebass'

import { PageHeader } from '../shared/PageHeader'
import { ProcessFlow } from '../shared/stepper/processFlowIndicator'

type ClaimDisplayProps = {
  children: React.ReactNode
}

const ClaimDisplay = ({ children }: ClaimDisplayProps) => (
  <Flex flexWrap="wrap">
    <Box width={[1, 15.6 / 16]}>
      <ProcessFlow active="claims" />
      <PageHeader />
      {children}
    </Box>
  </Flex>
)

export {
  ClaimDisplay
}
